import type {
  Action,
  Outcome,
  Tag,
  ServiceObject,
  PublishedAttribute,
  ReasonCodeGroup,
  List,
} from 'flow/store/engine/types';
import type { WorkflowPrimitive } from './types';


export function isAction(primitive: WorkflowPrimitive): primitive is Action {
  const discriminatingActionProperties: (keyof Action)[] = [
    'publicId',
    'serviceFailureDefault',
    'rules',
    'type',
  ];

  return discriminatingActionProperties.every(property => Object.hasOwn(primitive, property));
}

export function isOutcome(primitive: WorkflowPrimitive): primitive is Outcome {
  const discriminatingOutcomeProperties: (keyof Outcome)[] = [
    'customer_outcome_id',
    'is_case_status',
    'is_event_status',
    'outcome',
    'outcome_color',
  ];

  return discriminatingOutcomeProperties.every(property => Object.hasOwn(primitive, property));
}

export function isTag(primitive: WorkflowPrimitive): primitive is Tag {
  const discriminatingTagProperties: (keyof Tag)[] = [
    'tag_name',
    'tag_color',
    'is_case_creating',
    'suppression_interval',
  ];

  return discriminatingTagProperties.every(property => Object.hasOwn(primitive, property));
}

export function isService(primitive: WorkflowPrimitive): primitive is ServiceObject {
  const discriminatingServiceProperties: (keyof ServiceObject)[] = [
    'internal_name',
    'name',
    'service_id',
    'attributes',
    'sandbox_enabled',
  ];

  return discriminatingServiceProperties.every(property => Object.hasOwn(primitive, property));
}


export function isPublishedAttribute(
  primitive: WorkflowPrimitive,
): primitive is PublishedAttribute {
  const discriminatingPublishedAttributeProperties: (keyof PublishedAttribute)[] = [
    'attributeName',
    'attributeToken',
    'dataType',
    'defaultValue',
    'hasExpiration',
  ];

  return discriminatingPublishedAttributeProperties
    .every(property => Object.hasOwn(primitive, property));
}


export function isReasonCodeGroup(
  primitive: WorkflowPrimitive,
): primitive is ReasonCodeGroup {
  const discriminatingReasonCodeGroupProperties: (keyof ReasonCodeGroup)[] = [
    'id',
    'name',
    'reasonCodes',
    'services',
  ];

  return discriminatingReasonCodeGroupProperties
    .every(property => Object.hasOwn(primitive, property));
}

export function isList(primitive: WorkflowPrimitive): primitive is List {
  const discriminatingListProperties: (keyof List)[] = [
    'customer_list_id',
    'list_name',
    'is_blacklist',
    'is_whitelist',
    'list_token',
  ];

  return discriminatingListProperties
    .every(property => Object.hasOwn(primitive, property));
}
